import { ArrowBindingUtil } from "./bindings/arrow/ArrowBindingUtil.mjs";
const defaultBindingUtils = [ArrowBindingUtil];
export {
  defaultBindingUtils
};
//# sourceMappingURL=defaultBindingUtils.mjs.map
